import { organizationSchema } from '@billing/validation/organization';
import { Site } from 'interfaces';

export interface Organization {
  id: string;
  name: string;
  address: string;
  city: string;
  province: string;
  sites?: Site[];
}

export type FormOrganization = Omit<Organization, 'id'>;

export const isOrganization = (obj: any): obj is Organization => {
  return organizationSchema.safeParse(obj).success;
};
